import React from 'react'
import { graphql } from 'gatsby'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import { AnimationSliderContainer } from './AnimationContainer.style'
import AnimationStep from '../AnimationStep'
import { isMobile } from '../../../utils/siteHelper'

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2500,
}

const AnimationContainer = ({ animationSteps }) => (
  <AnimationSliderContainer>
    { isMobile() ? (
      animationSteps &&
        animationSteps.map(item => {
          return (
            <AnimationStep
              key={item.id}
              animationImage={item.animationImage}
              mobileImage={item.mobileImage}
              description={item.description}
            />
          )
        })
    ) : (
      <Slider {...settings}>
        {animationSteps &&
         animationSteps.map(item => {
           return (
             <AnimationStep
               key={item.id}
               animationImage={item.animationImage}
               mobileImage={item.mobileImage}
               description={item.description}
             />
           )
         })}
      </Slider>
    )
    }

  </AnimationSliderContainer>
)

AnimationContainer.propTypes = {
  animationSteps: PropTypes.arrayOf(PropTypes.shape({
    animationImage: PropTypes.shape({
      imageFile: PropTypes.object,
    }).isRequired,
    mobileImage: PropTypes.shape({
      imageFile: PropTypes.object,
    }).isRequired,
    description: PropTypes.string.isRequired,
  })).isRequired,
}

export const AnimationContainerFragment = graphql`
  fragment AnimationContainerFragment on ContentfulAnimationBlock {
    animationSteps {
      ...AnimationStepFragment
    }
  }
`

export default AnimationContainer
